// Temporary until the persistence client exports FlowEvent.
export enum FlowEvent {
	Annoyance = 'ANNOYANCE',
	Breakout = 'BREAKOUT',
	ThresholdExceeded = 'THRESHOLD_EXCEEDED'
}
